export function pharmacy_search_autocomplete() {
  if ($('.pharmacy-search-autocomplete').length > 0) {
    $('.pharmacy-search-autocomplete').each(function (index, element) {

      let $appendTo = $(element).parents('.form-pharmacy-search');
      let filter = {};

      $(element).autocomplete({
        serviceUrl: mea.ajax_url,
        type: 'GET',
        params: {
          action: 'get_autocomplete',
          filter: filter,
        },
        minChars: 3,
        groupBy: 'category',
        appendTo: $appendTo,
        deferRequestBy: 250,
        onSearchStart: function (params) {
          if (params.query == 'Aktueller Standort' || params.query == 'Gewählter Standort') {
            return false;
          }

          if (typeof $appendTo.data('filter') !== 'undefined') {
            filter = {};

            let dataFilter = $appendTo.data('filter').split('|');

            $.each(dataFilter, function (index, element) {
              filter[element] = true;
            });

            params.filter = filter;
            return params;
          } else if ($('.pharmacy-search-filter').length > 0) {
            filter = {};
            $.each($('.pharmacy-search-filter').find('.filter.active'), function () {
              filter[$(this).data('filter')] = true;
            });
            params.filter = filter;
            return params;
          }
        },
        formatResult: function (suggestion, currentValue) {
          var pattern = '(' + currentValue.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&') + ')';

          let result = suggestion.value
            .replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

          if (suggestion.data.category == 'Apotheken') {
            let address = suggestion.data.street + ' ' + suggestion.data.number + ', ' + suggestion.data.postcode + ' ' + suggestion.data.city;
            address = address
              .replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>')
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

            result = '<span class="autocomplete-suggestion-pharmacy-title">' + result + '</span><span class="autocomplete-suggestion-pharmacy-address">' + address + '</span>';
          } else {
            result = '<span class="autocomplete-suggestion-location">' + result + '</span>';
          }

          return result;
        },
        onSelect: function (suggestion) {
          if (suggestion.data.category == 'Apotheken') {
            window.location.href = suggestion.data.url;
          } else {
            $appendTo.submit();
          }
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/pharmacy-search-autocomplete.js